import { render, staticRenderFns } from "./Scientific.vue?vue&type=template&id=07f95684&scoped=true"
import script from "./Scientific.vue?vue&type=script&lang=js"
export * from "./Scientific.vue?vue&type=script&lang=js"
import style0 from "./Scientific.vue?vue&type=style&index=0&id=07f95684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f95684",
  null
  
)

export default component.exports